import React from 'react'

export function CopyButton({ text }: any) {
  return (
    <button
      type="button"
      className="btn copy-btn"
      onClick={() => {
        navigator.clipboard.writeText(text)
      }}
    >
      Copy
    </button>
  )
}
